module.exports = "mat-button-toggle {\n  color: #212121; }\n"